import SvgIcon from '@/pages/home/components/SvgIcon';
import React from 'react';
import classNames from 'classnames';

export const DropdownIcon = (props: {iconType: string; className: string; onClick: () => {};}) => {
  const { iconType, className, onClick } = props || {};
  return (
    <div className="close-icon" onClick={(e) => onClick?.(e)}>
      <i className={classNames('selectOther-flex-icon', {[className]: className})}
      >
        <SvgIcon type={iconType ? iconType : 'point-down'} />
      </i>
    </div>
  );
};
